module.exports = __webpack_public_path__ + "img/9788960512481.961e3a2e.jpg";